import { type FC, type ReactNode } from "react";
import { Icon } from "@root/shared/components/Icon";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import * as styles from "./styles.css";

export type AccordionProps = {
  title: ReactNode;
  children: ReactNode;
  accordionTheme?: "default" | "panel";
  isOpened: boolean;
  onClick?: () => void;
  ariaLabelPrefix?: string;
};

export const Accordion: FC<AccordionProps> = ({
  title,
  children,
  accordionTheme = "default",
  isOpened,
  onClick,
  ariaLabelPrefix,
}) => {
  const accordionThemeWithOpenedSuffix: "defaultIsOpened" | "panelIsOpened" =
    `${accordionTheme}IsOpened`;

  return (
    <div className={styles.wrapper[accordionTheme]}>
      <div className={styles.title[accordionTheme]}>
        <button
          className={styles.button[isOpened ? accordionThemeWithOpenedSuffix : accordionTheme]}
          type="button"
          onClick={onClick}
          aria-label={
            ariaLabelPrefix ? `${ariaLabelPrefix}${isOpened ? "を閉じる" : "を開く"}` : undefined
          }
        >
          {title}
          <div
            className={
              styles.iconWrapper[isOpened ? accordionThemeWithOpenedSuffix : accordionTheme]
            }
          >
            <Icon name="arrow-light-down" fontSize="22px" />
          </div>
        </button>
      </div>
      <div
        className={styles.contentsWrapper[accordionTheme]}
        style={assignInlineVars({
          [styles.contentDisplay]: isOpened ? "block" : "none",
        })}
        aria-expanded={isOpened}
        aria-label={
          // eslint-disable-next-line @typescript-eslint/no-base-to-string -- title は通常 string を想定。string 以外の ReactNode を渡した場合は "[object Object] コンテンツ" になる既存挙動を維持している（ariaLabelPrefix はボタン側の aria-label にのみ作用し、この div には効かない）
          `${title} コンテンツ`
        }
      >
        {children}
      </div>
    </div>
  );
};
